import ArticleCard from "@/components/common/cards/article_card";
import Typography from "@/components/common/typography";
import { Heading } from "@/components/common/typography/Heading";
import { DirectusFile } from "@directus/sdk";
import Image from "next/image";
import Link from "next/link";

export type BlogCard = {
  title: string;
  image: DirectusFile | null;
  category: { id: number; name: string; slug: string } | null;
  description: string;
  published: string;
  timeToRead: string;
  slug: string;
  press?: boolean;
  cardDataTestId?: string;
  cardDataImageTestId?: string;
  cardDataCategoryTextTestId?: string;
  cardDataTitleTestId?: string;
  cardDataDescriptionTestId?: string;
};
const BlogCard = ({
  title,
  press = false,
  category,
  description,
  published,
  image,
  timeToRead,
  slug,
  cardDataTestId,
  cardDataImageTestId,
  cardDataCategoryTextTestId,
  cardDataTitleTestId,
  cardDataDescriptionTestId,
}: BlogCard) => {
  const getDateParsed = () => {
    return new Date(published).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "2-digit",
      timeZone: "UTC",
    });
  };
  return (
    <article
      data-testid={cardDataTestId}
      className="flex  flex-col gap-3.5  lg:max-w-[25.8125rem] sm:max-h-none h-full rounded-lg "
    >
      <Link href={press ? `/press/${slug}` : `/blog/${slug}`}>
        <figure className="overflow-hidden aspect-[413/274] h-fit rounded-lg">
          <Image
            data-testid={cardDataImageTestId}
            width={413}
            height={274}
            className={`h-full w-full ${press ? "object-contain " : "object-cover"} rounded-card`}
            loading="lazy"
            src={
              image?.filename_disk || "7b796cf1-e866-42d2-9fc1-e55ceedbb845.jpg"
            }
            alt={image?.description || "Cover image for a blog"}
            priority={false}
            fetchPriority="low"
          />
        </figure>

        <div className="flex flex-col gap-1.5">
          <header className="flex flex-col mt-5">
            <Typography
              dataTestId={cardDataCategoryTextTestId}
              size="body2"
              color="main"
            >
              {category?.name || "Category"}
            </Typography>
          </header>

          <section className="flex flex-col gap-3.5 justify-between">
            <Heading dataTestId={cardDataTitleTestId} size="h5" as="h3">
              {title}
            </Heading>
            <Typography
              dataTestId={cardDataDescriptionTestId}
              className="line-clamp-3"
              size="body2"
              color="darkGray"
              dangerouslySetInnerHTML={{ __html: description }}
            ></Typography>
            <Typography size="body2" color="darkGray">
              {getDateParsed()} • {timeToRead || "6 mins to read."}
            </Typography>
          </section>
        </div>
      </Link>
    </article>
  );
};

export default BlogCard;
